/** Client-side liturgy types + schema constant (mirrors Functions). */

export const LITURGY_SCHEMA_VERSION = 1;

export type PackStatus = "draft" | "reviewed" | "published" | string;
export type ReadingSource = "usccb" | "awitatpapuri" | "manual";

export type SectionKind = "first" | "second" | "psalm" | "acclamation" | "gospel" | "other";

export type ReadingSectionItem = {
  body: string;
  sortOrder: number;
};

export type ReadingSection = {
  kind: SectionKind | string;
  citation: string;
  heading: string;
  body: string;
  /** Shared refrain / tugon — reuse after each `items[]` entry when rendering. */
  response?: string;
  items?: ReadingSectionItem[];
  sortOrder: number;
};

export type HealthResponse = {
  ok: boolean;
  phase: string;
  schemaVersion: number;
  cloudKitConfigured: boolean;
  appleAuthConfigured: boolean;
  firestoreConfigured?: boolean;
  firebaseProjectId?: string | null;
  containerId: string | null;
  environment: string;
};

export type LanguageSeed = {
  code: string;
  name: string;
  defaultSource: ReadingSource;
  sortOrder: number;
  isActive: boolean;
};

export type LiturgicalDayDto = {
  recordName: string;
  dateKey: string;
  liturgicalTitleEN: string | null;
  liturgicalTitleTL: string | null;
  season: string | null;
  rank: string | null;
  lectionaryNumber: string | null;
  color: string | null;
  isPublished: boolean;
  updatedAt: string | null;
};

export type ReadingPackSummaryDto = {
  recordName: string;
  dateKey: string;
  languageCode: string;
  massKey: string;
  source: string | null;
  status: PackStatus;
  liturgicalTitle: string | null;
  updatedAt: string | null;
  publishedAt: string | null;
};

export type ReadingPackDetailDto = ReadingPackSummaryDto & {
  sourceURL: string | null;
  sourceAttribution: string | null;
  lectionaryNumber: string | null;
  sections: ReadingSection[];
};

export type CalendarDayDto = {
  dateKey: string;
  weekday: number;
  day: LiturgicalDayDto | null;
  packs: ReadingPackSummaryDto[];
};

export type CalendarMonthResponse = {
  month: string;
  days: CalendarDayDto[];
  warnings: string[];
  configured: boolean;
  environment: string;
};

export type DayDetailResponse = {
  dateKey: string;
  day: LiturgicalDayDto | null;
  packs: ReadingPackDetailDto[];
  warnings: string[];
  configured: boolean;
  environment: string;
};
